export const UPI_PAYMENT = {payee: 'Asuremart', upiId: 'designermani90-1@okaxis', whatsapp: '919597172992'};
export const PENDING_PAYMENT_KEY = 'asure_pending_upi_payment';
export const getUpiPaymentLink = payment => {
    const params = new URLSearchParams({pa: UPI_PAYMENT.upiId, pn: UPI_PAYMENT.payee, cu: 'INR'});
    if (Number(payment?.amount) > 0) params.set('am', Number(payment.amount).toFixed(2));
    params.set('tn', payment?.orderNumber ? 'Asuremart order ' + payment.orderNumber : 'Asuremart order payment');
    return 'upi://pay?' + params.toString();
};
export const getPaymentWhatsAppLink = payment => {
    const text = ['Hello Asuremart, I have paid by UPI.',
        payment?.orderNumber && 'Order: ' + payment.orderNumber,
        payment?.orderId && 'Order ID: ' + payment.orderId,
        payment?.amount && 'Amount: INR ' + Number(payment.amount).toFixed(2),
        payment?.customerName && 'Customer: ' + payment.customerName,
        'UPI ID: ' + UPI_PAYMENT.upiId,
        'I am attaching my payment screenshot. Please verify my payment.'].filter(Boolean).join('\n');
    return 'https://wa.me/' + UPI_PAYMENT.whatsapp + '?text=' + encodeURIComponent(text);
};
export const createPendingPayment = (order, user, quotedAmount) => {
    const get = key => order?.[Object.keys(order || {}).find(name => name.toLowerCase() === key.toLowerCase())];
    const serverAmount = get('OrderTotal') ?? get('TotalAmount') ?? get('AmountPayable');
    const amount = Number(serverAmount ?? quotedAmount);
    if (!Number.isFinite(amount) || amount < 0) throw new Error('Unable to determine the order payment amount.');
    return {userId: String(user.UserID), orderId: get('OrderID') || null, orderNumber: get('OrderNumber') || null,
        amount: Math.round((amount + Number.EPSILON) * 100) / 100,
        customerName: [user.FirstName, user.LastName].filter(Boolean).join(' '),
        placedAt: new Date().toISOString(), status: 'awaiting-payment'};
};
